import { graphql, useStaticQuery } from 'gatsby';

export const useFooterData = () => {
  const data = useStaticQuery(graphql`
    query {
      footerDataJson {
        headline {
          html
        }
      }
    }
  `);

  return data.footerDataJson;
};
